export default __webpack_public_path__ + "static/media/drop-down-arrow.f862525e.svg";